import client from './client';

export const getFooterData = async () => {
  try { 
      const response = await client.get(  "/api/footer?populate=*" )
      //console.log("API Response getFooterData: ", response.data.data);
      return response.data.data;
  } catch (error) {
      if (error.response) {
          console.error('API Error:', error.response.data);
      } else if (error.request) {
          console.error('No response from server:', error.request); // Problema de conexión
      } else {
          console.error('Error configurando la solicitud:', error.message); // Otro error
      }
      throw error;
  }
} 